<template>
  <DatePickerComponent
    :value="value"
    :format="$dateFormatInput.split(' ')[0]"
    :floatLabelType="floatLabel ? 'Always' : 'Never'"
    :placeholder="placeholder"
    :showClearButton="false"
    cssClass="partner-console__ejs-datepicker"
    @update:value="$emit('update:value', $event)"
  />
</template>

<script>
/* This EJS component should be replaced with some better alternative as it functions with px-s, not em-s */
import { DatePickerComponent } from '@syncfusion/ej2-vue-calendars';

export default {
  props: {
    value: { type: Date, default: null },
    floatLabel: { type: Boolean, default: false },
    placeholder: { type: String, default: '' }
  },
  emits: ['update:value'],
  components: {
    DatePickerComponent,
  },
  computed: {
    dateValue() {
      return this.value ? new Date(this.value) : null;
    }
  }
}
</script>

<style>
.partner-console__ejs-datepicker {
  margin-bottom: 0 !important;
}
.partner-console__ejs-datepicker input {
  width: 12ch !important;
}
</style>